import {Component, OnInit} from '@angular/core';
import {WorkOrderService} from '../../../../Services/work-order.service';
import {BsToastService} from '../../../../Services/bs-toast-service';
import {ConfirmDialogService} from '../../../../Services/confirm-dialog.service';
import {WoType} from '../../../../DataModels/workorder-model';

@Component({
  selector: 'app-checklist-template-list',
  templateUrl: './checklist-template-list.component.html',
  standalone: false,
})
export class ChecklistTemplateListComponent implements OnInit {

  templates: any[] = [];
  woTypes: WoType[] = [];
  isLoaded = false;
  expandedId: string | null = null;
  editingTemplate: any = null;
  isNew = false;
  editingItem: any = null;
  isNewItem = false;

  constructor(
    private woService: WorkOrderService,
    private notification: BsToastService,
    public confirmDialog: ConfirmDialogService,
  ) {
  }

  ngOnInit(): void {
    this.woService.getWoTypes().subscribe({
      next: r => this.woTypes = r, error: () => {
      }
    });
    this.load();
  }

  load(): void {
    this.woService.getChecklistTemplates().subscribe({
      next: (r) => {
        this.templates = r;
        this.isLoaded = true;
      },
      error: () => {
        this.isLoaded = true;
      }
    });
  }

  startNew(): void {
    this.editingTemplate = {name: '', type_id: null, active: true};
    this.isNew = true;
  }

  startEdit(t: any): void {
    this.editingTemplate = {...t};
    this.isNew = false;
  }

  cancelEdit(): void {
    this.editingTemplate = null;
  }

  saveTemplate(): void {
    if (!this.editingTemplate?.name) {
      return;
    }
    const obs = this.isNew
      ? this.woService.createChecklistTemplate(this.editingTemplate)
      : this.woService.updateChecklistTemplate(this.editingTemplate.id, this.editingTemplate);
    obs.subscribe({
      next: () => {
        this.notification.showSuccessToast('Saved.');
        this.editingTemplate = null;
        this.load();
      },
      error: () => {
        this.notification.showErrorToast('Error saving.');
      }
    });
  }

  deleteTemplate(id: string): void {
    this.confirmDialog.confirmThis(['Delete this checklist template?'],
      () => {
        this.woService.deleteChecklistTemplate(id).subscribe({
          next: () => {
            this.notification.showSuccessToast('Deleted.');
            this.load();
          },
          error: () => {
            this.notification.showErrorToast('Error deleting.');
          }
        });
      }, () => {
      });
  }

  toggleExpand(id: string): void {
    this.expandedId = this.expandedId === id ? null : id;
    if (this.expandedId) {
      this.loadItems(id);
    }
  }

  loadItems(templateId: string): void {
    const t = this.templates.find(x => x.id === templateId);
    if (t) {
      this.woService.getChecklistItems(templateId).subscribe({
        next: (items) => {
          t.items = items;
        },
        error: () => {
        }
      });
    }
  }

  startNewItem(templateId: string): void {
    this.editingItem = {template_id: templateId, description: '', required: false, sort_order: 0};
    this.isNewItem = true;
  }

  cancelItem(): void {
    this.editingItem = null;
  }

  saveItem(): void {
    if (!this.editingItem?.description) {
      return;
    }
    const obs = this.isNewItem
      ? this.woService.createChecklistItem(this.editingItem.template_id, this.editingItem)
      : this.woService.updateChecklistItem(this.editingItem.template_id, this.editingItem.id, this.editingItem);
    obs.subscribe({
      next: () => {
        this.notification.showSuccessToast('Item saved.');
        this.editingItem = null;
        this.loadItems(this.expandedId!);
      },
      error: () => {
        this.notification.showErrorToast('Error saving item.');
      }
    });
  }

  deleteItem(templateId: string, itemId: string): void {
    this.confirmDialog.confirmThis(['Delete this checklist item?'],
      () => {
        this.woService.deleteChecklistItem(templateId, itemId).subscribe({
          next: () => {
            this.notification.showSuccessToast('Deleted.');
            this.loadItems(templateId);
          },
          error: () => {
            this.notification.showErrorToast('Error deleting.');
          }
        });
      }, () => {
      });
  }

  typeName(typeId: string | null): string {
    if (!typeId) {
      return '—';
    }
    return this.woTypes.find(t => t.id === typeId)?.name ?? typeId;
  }
}
